import about_us from '../../../img/about_us.png'
import { Link, useLocation } from "react-router-dom"
import { useEffect, useState } from 'react'
import { useAddNewHiringMutation } from "../../../features/hirings/hiringApiSlice"

import { useNavigate } from "react-router-dom"
// import ConfirmationPage from "../../confirmation/ConfirmationPage";


function validateEmail(email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
}
function validatePhone(phone) {
    const phonePattern = /^[2-9]\d{2}[2-9]\d{2}\d{4}$/;
    var digits = phone.replace(/\D/g, "");
    return phonePattern.test(digits)
}
function phoneFormat(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match && validatePhone(phoneNumberString)) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return null;
}


const About = () => {

    const [applicationSubmitted, setApplicationSubmitted] = useState(null)
    const [successClose, setSuccessClose] = useState(false)

    const [addNewHiring, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddNewHiringMutation()

    const location = useLocation()
    const navigate = useNavigate()

    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [phone, setPhone] = useState("")
    const [email, setEmail] = useState("")
    const [startDate, setStartDate] = useState("")
    const [applyFor, setApplyFor] = useState("")
    const [linkResume, setLinkResume] = useState("")
    const [completed, setCompleted] = useState(false)

    const canSave = [firstName, lastName, validateEmail(email), validatePhone(phone)].every(Boolean) && !isLoading

    let phoneFormatted = phoneFormat(phone)

    const onSaveHiringClicked = async (e) => {
        e.preventDefault()
        if (canSave) {
            const response = await addNewHiring({ firstName, lastName, email, phoneFormatted, startDate, applyFor, linkResume, completed }).then(
            )
            if (response) {
                setApplicationSubmitted(response.message)
                setSuccessClose(false)
                setFirstName("")
                setLastName("")
                setApplyFor("")
                setEmail("")
                setPhone("")
                setLinkResume("")
            }
        }

    }
    const handleScuccessClose = (e) => {
        e.preventDefault(e)
        setSuccessClose(true)
    }

    const input__incomplete = "bg-gray-50 border border-red-800 text-red-600 text-sm  focus:ring-blue-500 duration-300 ease focus:outline-none focus:border-red-700 hover:border-red-700 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
    const input__complete = "bg-gray-50 border border-green-800 text-gray-600 text-sm  focus:ring-blue-500 duration-300 ease focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 focus:outline-none focus:border-green-700 hover:border-green-700"

    const validFirstNameClass = !firstName ? input__incomplete : input__complete
    const validLastNameClass = !lastName ? input__incomplete : input__complete
    const validEmailClass = !validateEmail(email) ? input__incomplete : input__complete
    const validPhoneClass = !validatePhone(phone) ? input__incomplete : input__complete
    const validLinkResumeClass = !linkResume ? input__incomplete : input__complete
    const validStartDateClass = !startDate ? input__incomplete : input__complete
    const validApplyForClass = !applyFor ? input__incomplete : input__complete

    const content = (
        <>
            <div className=' container grid grid-cols-1 lg:grid-cols-2 mx-auto justify-between items-center lg:my-20 lg:gap-40'>
                <div className=' h-auto lg:h-screen space-y-4 mx-4 lg:mx-auto'>
                    <h5 className=' text-[16px] lg:text-[18px] font-Playfair font-bold text-mainColor my-4 text-center lg:text-left'>Our Story</h5>
                    <h1 className=' text-[30px] lg:text-[46px] font-Oswald font-black my-8 w-full lg:text-justify text-center'>More than Great Food</h1>
                    <p className=' font-Avenir text-[14px] lg:text-[16px] font-black text-gray-700 my-4 text-justify lg:tracking-wider leading-60'>Megenagna Mart and Café is an inviting Mart and Cafe designed to make our customers feel comfortable, happy about our food and services. we open 7 days a week from 9:00 a.m to 9:00 p.m. we also offer free wifi to our customers. Join our community and enjoy our native Ethiopian culture, as well as relax with old friends and make new ones</p>
                    <p className='font-Avenir text-[14px] lg:text-[16px] font-black text-gray-700 my-4 text-justify tracking-wider'>We welcome you to a fresh, testy delicious and traditional inspired Ethiopian dishes in our Mart and Cafe. From breakfast to dinner, we are waiting to serve you with excellence</p>
                </div>
                <div className='w-auto h-screen'>
                    <img
                        className="relative w-full px-4 lg:px-0 my-8 h-5/6 lg:h-full lg:my-0 object-cover object-center"
                        src={about_us} />
                </div>
            </div>
            <div className='container mx-auto justify-between items-center my-2 lg:my-10'>

                <div className=' mx-auto justify-between items-center text-center font-Oswald text-mainColor text-[18px] mt-0 lg:mt-40'><h1>Heritage</h1></div>
                <div className=' mx-auto justify-between items-center text-center font-Oswald text-[40px] font-semibold my-4 '><h1>Serving Greatness Since 2023</h1></div>

                <div className=' mx-auto justify-between items-center text-center font-Playfair text-mainColor text-[18px] mt-28 '><h1>Join the Team</h1></div>
                <div className=' mx-auto justify-between items-center text-center font-Oswald text-[40px] font-semibold my-4'><h1>We Are Hiring</h1></div>

                {
                    applicationSubmitted !== null && !successClose &&
                    <div className='my-10 gap-4 mx-auto md:w-[calc(100%-10rem)] lg:w-[calc(100%-20rem)] justify-between grid grid-cols-1'>
                        <div class="bg-green-100 py-2 px-4 rounded-sm text-slate-700 text-left flex justify-between gap-4 ">
                            <p>Thank you for your application, we have successfully received your application for the job you applied for and we will reach out to you if we want to move forward with your candidacy
                            </p>
                            <button
                                onClick={(e) => {
                                    handleScuccessClose(e)
                                }} class="cursor-pointer font-bold" ><sup>X</sup>
                            </button>
                        </div>
                    </div>
                }

                {/* _____________________________hiring form */}

                <div className=" my-10 gap-4 mx-auto md:w-[calc(100%-10rem)] lg:w-[calc(100%-20rem)] justify-between grid grid-cols-1 lg:grid-cols-2">

                    <div className=" w-full px-4 mx-auto">
                        <label htmlFor="firstName" className="block mb-2 text-[16px] font-Avenir text-red-600 dark:text-white">First Name</label>
                        <input
                            type="text"
                            name="firstName"
                            id="firstName"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            className={validFirstNameClass}

                        />
                    </div>
                    <div className=" w-full px-4 mx-auto">
                        <label htmlFor="lastName" className="block mb-2 text-[16px] font-Avenir text-red-600 dark:text-white">Last Name</label>

                        <input
                            type="text"
                            name="lastName"
                            id="lastName"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            className={validLastNameClass}
                        />
                    </div>
                    <div className=" w-full px-4 mx-auto">
                        <label htmlFor="email" className="block mb-2 text-[16px] font-Avenir text-red-600 dark:text-white">Email</label>

                        <input
                            type="email"
                            name="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className={validEmailClass}
                        />
                    </div>
                    <div className=" w-full px-4 mx-auto">
                        <label htmlFor="phone" className="block mb-2 text-[16px] font-Avenir text-red-600 dark:text-white">Phone</label>

                        <input
                            type="text"
                            name="phone"
                            id="phone"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            className={validPhoneClass}
                        />
                    </div>

                    <div className=" w-full px-4 mx-auto">
                        <label htmlFor="applyFor" className="block mb-2 text-[16px] font-Avenir text-red-600 dark:text-white">Position you apply for</label>
                        <select
                            type="applyFor"
                            name='applyFor'
                            value={applyFor}
                            defaultValue={applyFor}
                            onChange={e => setApplyFor(e.target.value)}
                            className={validApplyForClass}

                        >
                            {["", "Excutive Chef", "Food and Beverage Manager", "Kitchen Manager", "Restaurant Manager", "Waiter"].map((val, index) => (
                                <option key={index}>{val}</option>
                            ))}
                        </select>
                    </div>

                    <div className=" w-full px-4 mx-auto">
                        <label htmlFor="countries" className="block mb-2 text-[16px] font-Avenir text-red-600 dark:text-white"> Available start date*</label>
                        <div className="relative max-w-sm">

                            <input
                                type="date"
                                name="date"
                                id="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                className={validStartDateClass}

                            // className=" w-full p-2.5 bg-gray-50 border border-red-700 text-red-600 text-sm  focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            />
                        </div>
                    </div>
                    <div className=" w-full lg:col-span-2 px-4 mx-auto">
                        <label htmlFor="countries" className="block mb-2 text-[16px] font-Avenir text-red-600 dark:text-white">Link to your resume</label>

                        <input
                            type="text"
                            name="resume"
                            id="resume"
                            value={linkResume}
                            onChange={(e) => setLinkResume(e.target.value)}
                            className={validLinkResumeClass}

                        // className="bg-gray-50 border border-red-700 text-red-800 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        />
                    </div>

                </div>

                <div className='mx-4  md:mx-auto justify-center items-center text-center my-10'>
                    <button
                        onClick={(e) => onSaveHiringClicked(e)}

                        className=' w-full md:w-[200px] mx-auto justify-center items-center text-center bg-mainColor text-white p-2 md:p-3 cursor-pointer'>
                        Apply Now
                    </button>
                </div>


                {/* _____________________________hiring */}

            </div>
        </>
    )
    return content
}

export default About
